import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busserviceforcorporateinpune() {


const cardData = {
keyword: "Bus services for corporate in Pune",
headingDescription: "Ruturaj Enterprises provides reliable Bus services for corporate in Pune for employee transportation, office pickup and drop, corporate events, meetings, conferences, airport transfers, and official group travel. Companies can choose suitable AC, luxury, shuttle, or larger-capacity buses according to employee strength, route requirements, shift schedules, and event needs. From regular staff transportation to planned outstation corporate journeys, group bus arrangements can be organized around convenient pickup points, office locations, travel timings, and the company's transportation requirements.",
topPlaces: [
{
title: "Hinjewadi IT Park",
description: "Hinjewadi is one of Pune's major employment and technology hubs, with numerous offices and employees commuting throughout the day. Dedicated corporate buses can help organizations coordinate employee transportation between residential areas and workplaces while supporting scheduled pickup and drop requirements."
},
{
title: "Kharadi",
description: "Kharadi has developed into a major commercial and technology corridor with a large working population. Corporate bus transportation can provide an organized solution for employees traveling to offices, especially when companies need planned routes and scheduled staff movement."
},
{
title: "Magarpatta City",
description: "Magarpatta City is a prominent mixed-use business destination with offices, residential communities, and commercial facilities. A dedicated staff bus can simplify employee commuting by connecting office locations with multiple pickup points around Pune."
},
{
title: "Viman Nagar",
description: "Viman Nagar is an important commercial and corporate area located close to Pune Airport and several business establishments. Corporate buses can support employee commuting, business meetings, airport transfers, and group transportation requirements in and around the area."
},
{
title: "Baner",
description: "Baner has become a popular business and commercial area with offices, restaurants, hotels, and corporate establishments. Organizations can use dedicated buses for employee transportation, office events, meetings, and group travel requirements."
},
{
title: "Aundh",
description: "Aundh combines commercial offices, residential neighborhoods, and business facilities, making it a useful location for planned employee transportation routes. Corporate bus services can connect employees from nearby residential areas to offices according to fixed or customized schedules."
},
{
title: "Pimpri-Chinchwad",
description: "Pimpri-Chinchwad is an important industrial and commercial region with numerous companies and manufacturing facilities. Staff transportation through dedicated buses can help organizations manage daily employee movement across industrial areas and surrounding residential locations."
},
{
title: "Hadapsar",
description: "Hadapsar is a major employment corridor with offices, technology campuses, residential areas, and commercial establishments. Corporate transportation can be arranged to support employee pickup and drop services along routes connecting different parts of Pune."
},
{
title: "Pune Airport",
description: "Pune Airport is frequently used by corporate travelers, executives, employees, and business groups arriving for meetings and events. Dedicated corporate buses can provide convenient group transfers between the airport, offices, hotels, conference venues, and other planned destinations."
},
{
title: "Ranjangaon MIDC",
description: "Ranjangaon MIDC is an important industrial area where companies may require organized employee transportation from Pune and surrounding locations. Dedicated buses can support shift-based staff movement and planned transportation for industrial and corporate teams."
}
],
services: [
{
name: "Corporate Bus Service Pune",
description: "Corporate Bus Service Pune provides dedicated group transportation for employees, business teams, office events, meetings, and official travel. Ruturaj Enterprises can arrange suitable buses around employee strength, route requirements, pickup locations, and scheduled travel timings."
},
{
name: "Corporate Bus Rental Pune",
description: "Corporate Bus Rental Pune is suitable for companies that need buses for regular staff movement, special events, conferences, airport transfers, or corporate tours. Vehicle selection can be planned according to passenger capacity, journey distance, duration, and required comfort level."
},
{
name: "Corporate Bus Hire Pune",
description: "Companies can choose Corporate Bus Hire Pune for dedicated transportation during office functions, employee travel, business meetings, and group events. A suitable bus can be arranged according to the company's passenger count, route, schedule, and transportation requirements."
},
{
name: "Corporate Bus Booking Pune",
description: "Corporate Bus Booking Pune allows organizations to plan group transportation in advance for regular or one-time requirements. Companies can discuss employee numbers, pickup and drop points, office timings, event schedules, bus capacity, and preferred vehicle category."
},
{
name: "Corporate Staff Transportation Pune",
description: "Corporate Staff Transportation Pune helps organizations arrange convenient transportation for employees traveling between residential areas and workplaces. Dedicated buses can be planned around office locations, shift timings, pickup routes, and employee distribution across different parts of Pune."
},
{
name: "Corporate Employee Bus Service Pune",
description: "Corporate Employee Bus Service Pune provides an organized transportation option for employees commuting to and from offices. Route planning can be structured around multiple pickup points and work schedules, helping companies coordinate staff movement more efficiently."
},
{
name: "Corporate Office Bus Rental Pune",
description: "Corporate Office Bus Rental Pune is useful for companies requiring dedicated buses for daily commuting, office functions, employee transfers, and special business requirements. The transportation plan can be customized according to office location, staff strength, travel timings, and route coverage."
},
{
name: "Corporate Employee Pickup Drop Pune",
description: "Corporate Employee Pickup Drop Pune services are designed to support scheduled transportation between employee pickup locations and office premises. Dedicated buses can help organize regular commuting routes according to shift timings and the geographical distribution of employees."
},
{
name: "Corporate Staff Pickup Drop Bus Pune",
description: "Corporate Staff Pickup Drop Bus Pune provides a convenient shared transportation arrangement for employees working across different shifts. Routes and pickup points can be planned around the organization's operating hours, office location, and staff transportation requirements."
},
{
name: "AC Corporate Bus Pune",
description: "AC Corporate Bus Pune offers a comfortable transportation environment for employees and business groups during regular commuting and special corporate travel. Air-conditioned buses are particularly useful for longer routes, company events, airport transfers, and extended journeys."
},
{
name: "Luxury Corporate Bus Rental Pune",
description: "Luxury Corporate Bus Rental Pune is suitable for executives, corporate guests, premium employee transportation, business delegations, and special company events. Enhanced comfort and spacious interiors can provide a more professional travel experience for important corporate journeys."
},
{
name: "Corporate Event Bus Hire Pune",
description: "Corporate Event Bus Hire Pune helps organizations transport employees and guests to exhibitions, annual functions, product launches, celebrations, and other business events. Dedicated buses simplify group movement between offices, hotels, event venues, and return locations."
},
{
name: "Corporate Meeting Bus Rental Pune",
description: "Corporate Meeting Bus Rental Pune provides group transportation for employees, clients, managers, and business teams attending meetings at different locations. A dedicated bus can help coordinate participants traveling from offices, hotels, or common pickup points."
},
{
name: "Corporate Conference Bus Pune",
description: "Corporate Conference Bus Pune is useful for transporting employees, delegates, speakers, and business guests to conferences and professional events. Transportation can be coordinated around conference timings, venue locations, hotel pickups, and return schedules."
},
{
name: "Corporate Outstation Bus Pune",
description: "Corporate Outstation Bus Pune is designed for companies arranging employee trips, team outings, business visits, training programs, and corporate tours outside Pune. The bus can be arranged for one-day or multi-day journeys according to the organization's itinerary."
},
{
name: "Corporate Airport Transfer Bus Pune",
description: "Corporate Airport Transfer Bus Pune provides convenient group transportation between Pune Airport, offices, hotels, conference venues, and other business locations. It is useful when several employees, executives, or visiting delegates need to travel together with luggage."
},
{
name: "Corporate Employee Transport Pune",
description: "Corporate Employee Transport Pune offers dedicated group mobility for companies managing regular employee travel requirements. Routes can be structured around staff residential areas, office locations, shift timings, and the number of employees using the transportation service."
},
{
name: "Corporate Group Travel Bus Pune",
description: "Corporate Group Travel Bus Pune is suitable for teams traveling together for business meetings, training programs, conferences, celebrations, or company outings. Dedicated transportation keeps the group together and makes departure and arrival coordination easier."
},
{
name: "Affordable Corporate Bus Service Pune",
description: "Affordable Corporate Bus Service Pune provides a practical solution for organizations looking to manage employee and group transportation costs. Selecting an appropriately sized bus and planning efficient routes can help balance operating expenses with employee travel convenience."
},
{
name: "Corporate Shuttle Bus Pune",
description: "Corporate Shuttle Bus Pune can support regular transportation between offices, employee pickup points, business parks, parking areas, and nearby residential zones. Shuttle arrangements can be structured around fixed schedules, shift timings, and the company's daily commuting requirements."
},
{
name: "Corporate Travel Bus Rental Pune",
description: "Corporate Travel Bus Rental Pune provides dedicated group transportation for official tours, business visits, team travel, conferences, and company programs. Ruturaj Enterprises can arrange suitable buses according to passenger count, destination, travel duration, and itinerary."
},
{
name: "Corporate Transportation Service Pune",
description: "Corporate Transportation Service Pune covers employee commuting, office transfers, airport travel, meetings, conferences, events, and outstation corporate journeys. Transportation plans can be coordinated around employee strength, pickup routes, office schedules, and special company requirements."
}
],
tableData: [
["Corporate Bus Service Pune", "Corporate Bus Rental Pune"],
["Corporate Bus Hire Pune", "Corporate Bus Booking Pune"],
["Corporate Staff Transportation Pune", "Corporate Employee Bus Service Pune"],
["Corporate Office Bus Rental Pune", "Corporate Employee Pickup Drop Pune"],
["Corporate Staff Pickup Drop Bus Pune", "AC Corporate Bus Pune"],
["Luxury Corporate Bus Rental Pune", "Corporate Event Bus Hire Pune"],
["Corporate Meeting Bus Rental Pune", "Corporate Conference Bus Pune"],
["Corporate Outstation Bus Pune", "Corporate Airport Transfer Bus Pune"],
["Corporate Employee Transport Pune", "Corporate Group Travel Bus Pune"],
["Affordable Corporate Bus Service Pune", "Corporate Shuttle Bus Pune"],
["Corporate Travel Bus Rental Pune", "Corporate Transportation Service Pune"]
],
whychoose: [
{
WhyChooseheading: "Organized Employee Transportation",
WhyChoosedescription: "Daily employee commuting requires dependable route and timing coordination, particularly when staff work across different shifts. Ruturaj Enterprises can arrange dedicated buses around office locations, employee pickup points, and planned schedules."
},
{
WhyChooseheading: "Routes Around Major Business Hubs",
WhyChoosedescription: "Corporate transportation can be planned for employees working around Hinjewadi, Kharadi, Hadapsar, Baner, Viman Nagar, Pimpri-Chinchwad, and other business areas. Route planning can take into account the distribution of employees and the location of the workplace."
},
{
WhyChooseheading: "Comfortable AC Bus Options",
WhyChoosedescription: "Employees spend a significant amount of time commuting, making travel comfort an important consideration for corporate transportation. AC buses provide a more comfortable environment for daily staff movement as well as longer business journeys."
},
{
WhyChooseheading: "Suitable for Shift-Based Staff Travel",
WhyChoosedescription: "Companies operating multiple shifts may require transportation at different times of the day. Bus arrangements can be coordinated around office schedules, pickup routes, and shift timings to support organized employee movement."
},
{
WhyChooseheading: "Corporate Events and Conferences",
WhyChoosedescription: "Business events often require transportation for employees, delegates, clients, and guests between offices, hotels, airports, and event venues. Dedicated buses simplify group movement and help organizations coordinate transportation around fixed event schedules."
},
{
WhyChooseheading: "Airport Transfer Support",
WhyChoosedescription: "Corporate travelers and visiting business delegates may need coordinated airport transportation with adequate seating and luggage capacity. Dedicated buses can be used for group transfers between Pune Airport and offices, hotels, conference venues, or other business locations."
},
{
WhyChooseheading: "Flexible Bus Capacity",
WhyChoosedescription: "Corporate transportation requirements vary depending on workforce size and the type of journey. Companies can select a suitable bus according to the number of employees or guests traveling together, helping avoid unnecessary use of multiple vehicles."
},
{
WhyChooseheading: "Cost-Conscious Group Mobility",
WhyChoosedescription: "Centralizing employee or event transportation in dedicated group vehicles can simplify travel coordination and help manage transportation expenses. Ruturaj Enterprises can structure the bus requirement around the company's routes, passenger strength, schedules, and travel needs."
}
]
};













const faqData = [
{
question: "What are corporate bus services in Pune?",
answer: "Corporate bus services provide organized transportation for employees, business teams, meetings, events, office outings, and company travel requirements. Ruturaj Enterprises offers bus rental solutions that can be planned according to employee strength, route, schedule, pickup locations, and corporate travel needs."
},
{
question: "Can companies hire buses for employee transportation in Pune?",
answer: "Companies can arrange dedicated buses for employee transportation between office locations, residential areas, business parks, industrial areas, and other designated pickup points. A planned bus service can make daily or occasional employee movement more organized and convenient."
},
{
question: "What types of corporate trips can be arranged by bus in Pune?",
answer: "Corporate buses can be used for conferences, business meetings, employee outings, team-building activities, annual functions, training programs, client events, corporate picnics, and intercity business travel. The vehicle and schedule can be planned according to the specific purpose of the trip."
},
{
question: "Can corporate groups hire buses for outstation trips from Pune?",
answer: "Corporate teams can hire dedicated buses for outstation conferences, team tours, company events, employee excursions, and business travel. Ruturaj Enterprises can arrange group transportation based on the destination, passenger count, travel dates, itinerary, and expected duration."
},
{
question: "What bus seating capacities are available for corporate groups?",
answer: "Different bus capacities can be selected depending on the number of employees or team members traveling. Ruturaj Enterprises can help identify a suitable vehicle for small teams as well as larger corporate groups while considering seating requirements, luggage, route distance, and trip duration."
},
{
question: "Can a company book buses for corporate events in Pune?",
answer: "Dedicated buses can be arranged for corporate events, seminars, exhibitions, conferences, product launches, annual celebrations, and employee gatherings. Having planned transportation helps employees and guests reach the event venue according to a coordinated schedule."
},
{
question: "Are corporate bus services useful for employee team outings?",
answer: "A group bus is particularly useful for team outings because employees can travel together from a common pickup point or through planned stops. This simplifies transportation coordination and allows the company to manage departure, sightseeing, event, and return schedules more efficiently."
},
{
question: "Can corporate bus services be customized according to office requirements?",
answer: "Corporate transportation can be planned around specific requirements such as passenger strength, pickup points, destination, travel dates, reporting time, return schedule, and trip duration. Ruturaj Enterprises can discuss these details to help create a transportation arrangement suited to the company's itinerary."
},
{
question: "Can buses be hired for corporate travel from Pune to other cities?",
answer: "Companies can arrange bus transportation from Pune to other cities for meetings, conferences, training sessions, employee tours, and business events. Depending on the itinerary, destinations such as Mumbai, Nashik, Aurangabad, Hyderabad, Bengaluru, Goa, and other cities can be included."
},
{
question: "Why choose Ruturaj Enterprises for corporate bus services in Pune?",
answer: "Ruturaj Enterprises provides group transportation solutions for businesses that need organized employee and corporate travel. Vehicle selection and trip planning can be aligned with passenger numbers, routes, schedules, and event requirements, helping companies manage group transportation with greater convenience."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rohit Kulkarni",
feedback:
"Our company required a bus for an employee outing in Pune, and Ruturaj Enterprises helped us arrange suitable group transportation. The team could travel together according to our planned schedule, which made coordination much easier. The overall bus arrangement was convenient for our corporate event.",
rating: 5
},
{
id: 2,
name: "Miss. Snehal Patil",
feedback:
"We hired a bus for our corporate team trip from Pune and were pleased with how simple the group travel arrangement was. Having everyone in one vehicle helped us manage pickup and return timings efficiently. Ruturaj Enterprises was a practical choice for our company's transportation requirement.",
rating: 5
}
];
































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus services for corporate in Pune",
  "image": "https://ruturajenterprises.com/assets/images/bus-services-for-corporate-in-pune.webp",
  "description":
    "Bus services for corporate in Pune designed for employee transportation, office commuting, corporate events, business meetings, conferences, training programs, and company outings. Ruturaj Enterprises provides comfortable AC and luxury bus rental options with suitable seating capacities, professional drivers, planned pickup and drop routes, flexible schedules, and dependable transportation solutions for corporate teams across Pune and nearby areas.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/bus-services-for-corporate-in-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>
    Bus services for corporate in Pune | Corporate Bus Rental Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Bus services for corporate in Pune for employee transportation, office commuting, corporate events, conferences, training programs and company outings. Hire comfortable AC and luxury buses with flexible routes, schedules and seating options."
  />

  <meta
    name="keywords"
    content="Corporate Bus Service Pune, Corporate Bus Rental Pune, Corporate Bus Hire Pune, Corporate Bus Booking Pune, Corporate Staff Transportation Pune, Corporate Employee Bus Service Pune, Corporate Office Bus Rental Pune, Corporate Employee Transportation Pune, Corporate Staff Bus Rental Pune, Corporate Staff Bus Hire Pune, Employee Transportation Service Pune, Employee Bus Rental Pune, Employee Bus Hire Pune, Office Staff Transportation Pune, Office Bus Rental Pune, Office Bus Hire Pune, Company Bus Rental Pune, Company Employee Transport Pune, Corporate Transportation Service Pune, Corporate Travel Bus Pune, Corporate Event Bus Rental Pune, Corporate Event Bus Hire Pune, Corporate Event Transportation Pune, Bus for Corporate Events Pune, Bus for Corporate Meetings Pune, Bus for Corporate Conference Pune, Bus for Corporate Training Pune, Bus for Corporate Outing Pune, Corporate Picnic Bus Pune, Corporate Tour Bus Pune, Corporate Group Transportation Pune, Corporate Shuttle Bus Service Pune, Corporate Shuttle Bus Rental Pune, Employee Shuttle Service Pune, Office Pickup Drop Bus Pune, Corporate Pickup Drop Service Pune, Employee Pickup Drop Transportation Pune, AC Corporate Bus Rental Pune, Luxury Corporate Bus Rental Pune, Corporate Mini Bus Rental Pune, Corporate Bus on Rent Pune, Corporate Bus Booking Service Pune, Corporate Bus Rental Near Me Pune, Affordable Corporate Bus Rental Pune, 20 Seater Corporate Bus Pune, 32 Seater Corporate Bus Pune, 35 Seater Corporate Bus Pune, 45 Seater Corporate Bus Pune, 50 Seater Corporate Bus Pune, Corporate Bus for Outstation Pune, Corporate Bus for Airport Transfer Pune, Corporate Bus for Business Travel Pune, Corporate Bus for Company Trip Pune, Corporate Bus for Annual Function Pune, Corporate Bus for Industrial Visit Pune, Ruturaj Enterprises Corporate Bus Service Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busserviceforcorporateinpune;